export default __webpack_public_path__ + "static/media/Picture16.c616dad0.png";